import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/(app)/ops/delivery/")({
  beforeLoad: () => {
    throw redirect({ to: "/ops/delivery/outbox" });
  },
});
